// Constants
import Endpoints from '@/constants/endpoints';
import Constants from '@/constants/constants';

// Services
import UtilsService from '@/core/services/utils.service';
import $http from '@/core/services/http.service';

// Models
import { Purchase } from '@/clickbuy/purchase/models/purchase.model';


export class PurchaseService {
    public static downloadCsv(idConvocation: string, filters: any): void {
        const baseUrl = process.env.VUE_APP_BASE_URI_API;
        const baseEndpoint = `${Endpoints.purchase}`;
        var params = undefined
        if(Object.values(filters).some(value => value != null && value != "")){
            params = UtilsService.getQueryParamsFormatted(filters) + `&limit=${Constants.downloadCsvLimit}`;
        } else {
            params = `?limit=${Constants.downloadCsvLimit}`
        }
        const url = `${baseUrl}${baseEndpoint}convocation/${idConvocation}/csv/${params}`;
        window.location.href = url;
    }

    public static moneyFlow(client: string, convocation: string): any {
        const payload = {
            queryParams: {
                client,
                convocation,
            },
        };
        const params = UtilsService.getQueryParams(payload);
        return $http.get(`${Endpoints.moneyFlows}`, { params });
    }

    public static purchaseUrl(purchase: Purchase) {
        const purchaseId = purchase.id || '';
        return Endpoints.purchaseDocument(purchaseId);
    }

    public static billUrl(purchase: any) {
        const billId = (purchase.bill as any).id || '';
        return Endpoints.billDocument(billId);
    }
    public static async fetchPurchaseParticipantList(purchaseId: string) {
        const list = await $http.get(Endpoints.purchaseParticipant(purchaseId));
        return list.data;
    }

    public static sendPurchaseDocument(idPurchase: string, filters: any) {
        const params = UtilsService.getQueryParamsFormatted(filters);
        return $http.post(`${Endpoints.purchaseDocumentSend(idPurchase)}${params}`);
    }

    public static sendAllBills(idConvocation: string, filters: any) {
        // const params = UtilsService.getQueryParamsFormatted(filters);
        // return $http.get(`${Endpoints.purchaseSendAllBill()}${params}`);

        const baseUrl = process.env.VUE_APP_BASE_URI_API;
        const baseEndpoint = `${Endpoints.purchase}`;

        var params = undefined
        if(Object.values(filters).some(value => value != null && value != "")){
            params = UtilsService.getQueryParamsFormatted(filters) + `&limit=${Constants.downloadCsvLimit}`;
        } else {
            params = `?limit=${Constants.downloadCsvLimit}`
        }

        return $http.get(`${Endpoints.purchaseSendAllBill(idConvocation)}${params}`);

    }
}
